export enum ETypeParking {
  EVENT_PARKING = 'event_parking',
  ON_STREET_PARKING = 'on_street_parking',
  PARKING_LOT = 'parking_lot',
  PRIVATE_PARKING = 'private_parking',
  RESIDENCE = 'residence',
  VALET_PARKING = 'valet_parking',
}
